import { gql } from '@apollo/client';

export const ResendVerifCode = gql`
    mutation resendVerificationCode($email: String!, $type: Int!, $phoneNumber: String) {
        resendVerificationCode(email: $email, type: $type, phoneNumber: $phoneNumber) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
